import React, { useMemo } from "react";
import { useSupplyReportStore } from "../../stores/supplyReportStore";
import { formatDate } from "utils/format";
import { noImage } from "assets";

const pageMap = {
  1: "Готівка Польща",
  2: "ОПТ Замовлення Україна",
  3: "Прихід - Замовлення Польща на ТОВ ІМПОРТ",
};

// Компонент для відображення таблиці очікуваних поставок
const SupplyReportTable = React.memo(() => {
  const data = useSupplyReportStore((state) => state.data);
  const sort_by = useSupplyReportStore((state) => state.filters.sort_by);
  const sort_asc = useSupplyReportStore((state) => state.filters.sort_asc);
  const setSort = useSupplyReportStore((state) => state.setSort);

  const headers = useMemo(
    () => [
      { label: "Дата замов.", field: "order_date" },
      { label: "Дата приходу", field: "arrival_date" },
      { label: "Фото", field: "img_url", sortable: false },
      { label: "Назва товару", field: "product_name" },
      { label: "Артикул", field: "sku" },
      { label: "Постачальник", field: "provider_source" },
      { label: "Кількість", field: "quantity" },
      { label: "Залишок", field: "stock_balance" },
      { label: "Орієнтовна ціна", field: "estimated_price" },
      { label: "Статус", field: "status" },
      { label: "Примітка", field: "additional_info" },
      { label: "Джерело", field: "page" },
    ],
    [],
  );

  const renderCellValue = (item, field) => {
    const value = item[field];

    if (field === "img_url") {
      return (
        <img
          src={value || noImage}
          alt={item.product_name || "фото"}
          className={value ? "clickable" : ""}
          onClick={() => value && window.open(value, "_blank")}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = noImage;
          }}
        />
      );
    }

    if (value === null || value === undefined || value === "") {
      return "—";
    }

    switch (field) {
      case "order_date":
      case "arrival_date":
        return formatDate(value);
      case "estimated_price": {
        const price = Number(value);
        return Number.isNaN(price)
          ? value
          : `${price.toLocaleString("uk-UA", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })} грн`;
      }
      case "page":
        return pageMap[value] || value;
      case "status":
        const isPartial = value === "Частково доставлено";
        return (
          <span className={`status-badge ${isPartial ? "status-partial" : ""}`}>
            {value}
          </span>
        );
      default:
        return value;
    }
  };

  return (
    <table id="supply-report-table">
      <thead>
        <tr>
          {headers.map(({ label, field, sortable = true }) => (
            <th
              key={field}
              className={sortable ? "clickable" : ""}
              onClick={sortable ? () => setSort(field) : undefined}
            >
              {label}
              {sortable && field === sort_by && (sort_asc ? " ▲" : " ▼")}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.length === 0 ? (
          <tr>
            <td colSpan={headers.length} className="empty-row">
              Немає даних товарів на приході
            </td>
          </tr>
        ) : (
          data.map((item, index) => (
            <tr key={`${item.sku}-${index}`}>
              {headers.map(({ label, field }) => (
                <td
                  key={field}
                  data-label={label}
                  className={field === "img_url" ? "photo" : ""}
                >
                  {renderCellValue(item, field)}
                </td>
              ))}
            </tr>
          ))
        )}
      </tbody>
    </table>
  );
});

export default SupplyReportTable;
